module.exports = __webpack_public_path__ + "static/10-885efb06ab96f05a8300a234d4ff9851.jpg";